<template>
  <div class="noticias-mode">
    <ProducaoBar
      :is-midias-moderacao="false"
      :cod_pasta="cod_pasta"
      :selected-tab-number="1"
    />
    <v-row class="ma-0 pa-5">
      <v-col>
        <NoticiasAprovadas
          v-if="cod_producao && cod_portal && noticiasAprovadas"
          :data="noticiasAprovadas"
          :cod_producao="cod_producao"
          :current-aprovadas-page="page"
          :changePasta="changePasta"
        />
        <v-pagination
          v-if="noticiasAprovadas"
          class="mt-5"
          v-model="page"
          :length="noticiasAprovadas.totalPages || 1"
          @input="handleAprovadasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
      <v-col>
        <NoticiasModeradas
          v-if="cod_producao && cod_portal && noticiasModeradas"
          :data-moderada="noticiasModeradas"
          :cod_producao="cod_producao"
          :aprovadas_current_page="page"
          :page-moderada="pageModerada"
          :cod_pasta="cod_pasta"
        />
        <v-pagination
          v-if="noticiasModeradas"
          class="mt-5"
          v-model="pageModerada"
          :length="noticiasModeradas.totalPages || 1"
          @input="handleModeradasPageChange"
          :total-visible="paginasExibidas"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ProducaoBar from "../components/Producao/ProducaoBar.vue";
import NoticiasAprovadas from "../components/Noticias/NoticiasAprovadas.vue";
import NoticiasModeradas from "../components/Noticias/NoticiasModeradas.vue";
import { apiClient } from "@/services/api";

export default {
  name: "NoticiasView",
  components: {
    ProducaoBar,
    NoticiasAprovadas,
    NoticiasModeradas,
  },
  data() {
    return {
      isDark: this.$vuetify.theme.dark,
      cod_producao: null,
      cod_portal: null,
      page: 1,
      pageModerada: 1,
      size: 5,
      paginasExibidas: 9,
      timerAprovada: null,
      timerModerada: null,
      cod_pasta: 0,
      cod_editoria: null,
    };
  },
  beforeCreate() {
    if (!this.$store.state.users.isAuthenticated) {
      apiClient.interceptors.request.use(
        (config) => {
          const token = this.$route.query.token || null;

          if (token) {
            config.headers["x-access-token"] = token;
          }
          return config;
        },
        (error) => {
          console.error(error);
          return Promise.reject(error);
        }
      );
    }
    if (this.$store.state.moderacao.modoModeracao === 1) {
      this.$vuetify.theme.themes.dark = this.$vuetify.theme.framework.theme.defaults.noticiasDark;
      this.$vuetify.theme.themes.light = this.$vuetify.theme.framework.theme.defaults.noticiasLight;
    }
  },
  async created() {
    const localStorageCodProducao =
      this.$store.state.producoes.selectedProducao?.cod_producao ||
      parseInt(this.$route.query.cod_producao);
    const localStorageCodPortal =
      localStorage.getItem("@socialcam/cod_portal") || this.$route.query.cod_portal;
    if (localStorageCodProducao) {
      this.cod_producao = localStorageCodProducao;
    }
    const flg_favorita =
      JSON.parse(localStorage.getItem("@socialcam/flg_favorita_noticias")) || false;
    this.setFlgFavorita(flg_favorita);
    if (localStorageCodPortal) {
      this.cod_portal = localStorageCodPortal;
    }
    if (this.cod_producao && this.cod_portal) {
      await Promise.all([
        this.getNoticiasAprovadas({
          cod_portal: this.cod_portal,
          cod_producao: this.cod_producao,
          page: this.page,
          size: this.size,
          flg_favorita: this.$store.state.noticias.flg_favorita,
          filtro_texto: this.filtroAprovadas,
          cod_pasta: this.cod_pasta,
          cod_editoria: this.$store.state.portais?.selectedEditoria,
        }),
        this.getNoticiasModeradas({
          cod_producao: this.cod_producao,
          cod_portal: this.cod_portal,
          page: this.pageModerada,
          size: this.size,
          filtro_texto: this.filtroModeradas,
        }),
        this.getPastas({
          cod_producao: this.cod_producao,
        }),
      ]);
      this.updateTimers();
    }
  },
  beforeDestroy() {
    clearInterval(this.timerAprovada);
    clearInterval(this.timerModerada);
  },
  methods: {
    ...mapActions({
      getNoticiasAprovadas: "noticias/getNoticiasAprovadas",
      getNoticiasModeradas: "noticias/getNoticiasModeradas",
      getProducoes: "producoes/getProducoes",
      setFlgFavorita: "noticias/setFlgFavorita",
      getPastas: "pastas/getPastas",
    }),
    changeTheme(e) {
      localStorage.setItem("@socialcam/is_dark_theme", e);
      this.$vuetify.theme.dark = e;
    },
    async changePasta(cod_pasta) {
      this.cod_pasta = cod_pasta;
      this.updateTimers();
    },
    async handleAprovadasPageChange() {
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal?.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        page: this.page,
        size: this.size,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        filtro_texto: this.filtroAprovadas,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.$store.state.portais.selectedEditoria,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    async handleModeradasPageChange() {
      await this.getNoticiasModeradas({
        cod_portal: this.$store.state.portais.selectedPortal?.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        page: this.pageModerada,
        size: this.size,
        filtro_texto: this.filtroModeradas,
      });
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    updateTimers() {
      clearInterval(this.timerAprovada);
      clearInterval(this.timerModerada);

      this.timerAprovada = setInterval(() => {
        this.getNoticiasAprovadas({
          page: this.$store.state.noticias.noticiasAprovadas
            ? this.$store.state.noticias.noticiasAprovadas.currentPage
            : this.page,
          size: this.size,
          cod_portal: this.$store.state.portais.selectedPortal?.cod_portal ?? "",
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          flg_favorita: this.$store.state.noticias.flg_favorita,
          filtro_texto: this.filtroAprovadas,
          cod_pasta: this.cod_pasta,
          cod_editoria: this.$store.state.portais.selectedEditoria,
        });
      }, 60000); // Chama a função a cada 1 minuto.

      this.timerModerada = setInterval(() => {
        this.getNoticiasModeradas({
          page: this.$store.state.noticias.noticiasModeradas
            ? this.$store.state.noticias.noticiasModeradas.currentPage
            : this.page,
          size: this.size,
          cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
          cod_portal: this.$store.state.portais.selectedPortal?.cod_portal ?? "",
          filtro_texto: this.filtroModeradas,
        });
      }, 60000); // Chama a função a cada 1 minuto.
    },
  },
  computed: {
    ...mapGetters({
      dark_theme: "themes/getTheme",
      noticiasModeradas: "noticias/getterNoticiasModeradas",
      noticiasAprovadas: "noticias/getterNoticiasAprovadas",
      filtroAprovadas: "noticias/getterFiltroAprovadas",
      filtroModeradas: "noticias/getterFiltroModeradas",
    }),
  },
  watch: {
    "$store.state.producoes.selectedProducao": async function (newValue) {
      this.cod_producao = newValue.cod_producao;
      if (this.cod_portal) {
        await this.getPastas({
          cod_producao: this.cod_producao,
        });
        await this.getNoticiasModeradas({
          cod_producao: this.cod_producao,
          cod_portal: this.cod_portal
            ? this.cod_portal
            : this.$store.state.portais.selectedPortal?.cod_portal,
          page: this.pageModerada,
          size: this.size,
          filtro_texto: this.filtroModeradas,
        });
        await this.getNoticiasAprovadas({
          cod_portal: this.cod_portal
            ? this.cod_portal
            : this.$store.state.portais.selectedPortal?.cod_portal,
          cod_producao: this.cod_producao
            ? this.cod_producao
            : this.$store.state.producoes.selectedProducao.cod_producao,
          page: this.page,
          size: this.size,
          flg_favorita: this.$store.state.noticias.flg_favorita,
          filtro_texto: this.filtroAprovadas,
          cod_pasta: this.cod_pasta,
          cod_editoria: this.$store.state.portais.selectedEditoria,
        });
      }
    },
    "$store.state.portais.selectedPortal": async function (newValue) {
      this.cod_portal = newValue.cod_portal;
      await this.getPastas({
        cod_producao: this.cod_producao,
      });
      await this.getNoticiasAprovadas({
        cod_portal: this.$store.state.portais.selectedPortal?.cod_portal,
        cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
        page: this.page,
        size: this.size,
        flg_favorita: this.$store.state.noticias.flg_favorita,
        filtro_texto: this.filtroAprovadas,
        cod_pasta: this.cod_pasta,
        cod_editoria: this.$store.state.portais.selectedEditoria,
      });
      if (this.cod_producao) {
        await this.getNoticiasModeradas({
          cod_producao: this.cod_producao,
          cod_portal: this.cod_portal,
          page: this.pageModerada,
          size: this.size,
          filtro_texto: this.filtroModeradas,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
